<template>
    <div v-if="showModal" id="user_edit_modal" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <div id="header" class="ui left aligned segment">
                <h3 class="ui header">정보변경</h3>
            </div>
            <div id="body" class="ui left aligned segment">
                <form class="ui form">
                    <table class="inline field ui very basic table">
                        <tr>
                            <td class="collapsing">
                                <!-- <div class="ui checkbox">
                                    <input type="checkbox" v-model="editId">
                                    <label>아이디</label>
                                </div> -->
                                <label>아이디</label>
                            </td>
                            <td>
                                <div class="ui fluid input">
                                    <input type="text" name="id" v-model="id" autocomplete=off :disabled="!editId">
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="collapsing">
                                <div class="ui checkbox">
                                    <input type="checkbox" v-model="editPassword">
                                    <label>비밀번호</label>
                                </div>        
                            </td>
                            <td>
                                <input type="text" name="password" v-model="password" placeholder="새 비밀번호를 입력하세요" autocomplete=off :disabled="!editPassword">
                            </td>
                        </tr>
                        <tr>
                            <td class="collapsing">
                                <div class="ui checkbox">
                                    <input type="checkbox" v-model="editName">
                                    <label>이름</label>
                                </div>        
                            </td>
                            <td>
                                <input type="text" name="name" v-model="name" autocomplete=off :disabled="!editName">
                            </td>
                        </tr>
                    </table>
                </form>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui form">
                    <div class="inline field">
                        <input v-if="checkChanged()" type="password" name="password" placeholder="기존 비밀번호 입력" v-model="oldPassword">
                        <div v-if="checkChanged()" class="ui orange left labeled icon button" @click="save">
                            <i class="checkmark icon"></i>저장
                        </div>
                        <div class="ui button" @click="close">닫기</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return { showModal: 0, id: 0, name: 0, password: 0, editId: 0, editName: 0, editPassword: 0, oldPassword: 0,  }
    },
    created: function() {
        this.showModal = false;
        this.id = this.name = this.password = 0;
        this.editId = this.editName = this.editPassword = 0;
        this.oldPassword = "";
    },
    mounted: function() {
        this.$event.set("openUserEdit", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("openUserEdit");
    },
    methods: {
        open() {
            this.showModal = true;
            this.id = this.user.id;
            this.password = "";
            this.name = this.user.name;
            this.editId = false;
            this.editName = false;
            this.editPassword = false;
            this.oldPassword = "";
        },
        close() {
            this.showModal = false;
        },
        save() {
            this.$event.call("openLoading");
            const newId = (this.editId && Boolean(this.id)) ? this.id : "";
            const newPassword = (this.editPassword && Boolean(this.password)) ? this.password : "";
            const newName = (this.editName && Boolean(this.name)) ? this.name : "";
            this.$api.editUser(this.user._id, this.oldPassword, newId, newPassword, newName, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.user.id = resData.id;
                    this.user.name = resData.name;
                    this.close();
                }
            });
        },
        checkChanged() {
            if (this.editId && Boolean(this.id) && this.id !== this.user.id) return true;
            if (this.editName && Boolean(this.name) && this.name !== this.user.name) return true;
            if (this.editPassword && Boolean(this.password)) return true;
            return false;
        },
        onResponse(resData) {
            
        }
    },
    computed: {
        user: function() { return this.$store.getters.user; },
    },
    watch: {
        id: function(val) { this.id = this.$validator.replaceAlphaKorNum(val).substring(0, 12).toLowerCase(); },
        password: function(val) { this.password = this.$validator.replaceAlphaNum(val).substring(0, 12).toLowerCase(); },
        name: function(val) { this.name = this.$validator.replaceAlphaKorNumBracket(val).substring(0, 10); },
    },
}
</script>

<style>

#user_edit_modal {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 50;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#user_edit_modal .column {
    max-width: 500px;
}

#user_edit_modal #header {
    padding: 20px 30px;
}

#user_edit_modal #body {
    padding: 0;
}

#user_edit_modal #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#user_edit_modal #footer .ui.form {
    padding: 0;
}

#user_edit_modal .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/UserEditModal.vue